import axios from "axios";
import { handleResponse, handleError } from "./apiUtils";
// const baseUrl = process.env.API_URL + "/templates/";

const baseUrl = `${window.appLocalizer.apiUrl}/wprk/v1/templates`;
const nonce = window.appLocalizer.nonce;

// const baseUrl = `http://localhost/wordpress/wp-json/wprk/v1/templates`;
// const nonce = `5c74968270`;
// const cookie =
//   "wordpress_test_cookie=WP Cookie check; wordpress_logged_in_bbfa5b726c6b7a9cf3cda9370be3ee91=VigneshDeva06|1641619925|mDbcLbkXx6QCfpRISDBiFZQO7lySqhkI7LYQ1NAMTNm|b7b6ab30b0dbc572397bd597fa353f2f6beb02b330988ca3c0336054c0fa071c; wp-settings-time-1=1641447151";

const headers = {
  "X-WP-NONCE": nonce,
//  Cookie: cookie,
  "Content-Type": "application/json",
};

export function getTemplates() {
  return axios
    .get(baseUrl, { headers, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}
export function getTemplate(templateId) {
  const url = baseUrl + "/" + templateId;
  return axios
    .get(url, { headers, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteTemplate(templateId) {
  const url = baseUrl + "/" + templateId;
  return axios
    .delete(url, { method: "DELETE", headers, withCredentials: true })
    .then(handleResponse)
    .catch(handleError);
}

export function deleteTemplates(templateIds) {
  console.log("templateIds", templateIds);
  const url = baseUrl.slice(0, baseUrl.length - 1) + "/" + "bulk_delete";
  return axios
    .delete(url, {
      method: "DELETE",
      headers,
      withCredentials: true,
      data: JSON.stringify({ templateIds }),
    })
    .then(handleResponse)
    .catch(handleError);
}

export function updateTemplate(templateId, templateBody) {
  const data = JSON.stringify({ template: templateBody });
  return axios(baseUrl, {
    method: "PUT",
    headers,
    data,
    withCredentials: true,
  })
    .then(handleResponse)
    .catch(handleError);
}
export function createTemplate(templateBody) {
  console.log(
    "🚀 ~ file: templateApi.js ~ line 47 ~ createTemplate ~ templateBody",
    templateBody
  );
  const data = JSON.stringify({ template: templateBody });
  return axios(baseUrl, {
    method: "POST",
    headers,
    data,
    withCredentials: true,
  })
    .then(handleResponse)
    .catch(handleError);
}
